import { fetch } from "~/utils/helper";
import { HELP_GENERAL, helpTopicOf } from "~/utils/onboarding";

// A question for the team, from anywhere in the dashboard: one form (components/onboarding/HelpDialog.vue, mounted by the
// layouts), opened on the topic of the screen that asks. The API rings the team on Slack and records the question on the
// account's CRM record (POST /accounts/:id/help); the person is answered by e-mail, or called back.
export const CONTACT_EMAIL = "contact@printags.com";

export const useHelpDesk = () => {
  const state = useState("help-desk", () => ({ open: false, topic: HELP_GENERAL, callback: false, message: "" }));

  // `topic`: a step key (utils/onboarding.js, STEPS) or nothing for a general question; `callback` opens on a callback;
  // `message` starts the question (the cancellation of a plan the team gave, for instance).
  const ask = (topic = HELP_GENERAL, { callback = false, message = "" } = {}) => {
    state.value = { open: true, topic: helpTopicOf(topic), callback, message };
  };

  // Resolves to "sent", or "unreachable" when nobody could take it: the form then gives the address to write to.
  const send = async ({ topic, message, callback, phone }) => {
    try {
      const res = await fetch("/accounts/:accountId/help", {
        method: "POST",
        body: { topic, message, callback, ...(callback ? { phone } : {}) }
      });
      return res?.success ? "sent" : "unreachable";
    } catch (error) {
      return error?.code === "BAD_REQUEST" ? "invalid" : "unreachable";
    }
  };

  return { state, ask, send };
};
